import { AppleLogo } from '@jouzen/ecom-components/icons/AppleLogo';
import { ClueLogo } from '@jouzen/ecom-components/icons/ClueLogo';
import { FloLogo } from '@jouzen/ecom-components/icons/FloLogo';
import { GoogleHealthConnectLogo } from '@jouzen/ecom-components/icons/GoogleHealthConnectLogo';
import { NaturalCyclesLogo } from '@jouzen/ecom-components/icons/NaturalCyclesLogo';

import type { LandingPageIntegrationData } from '@/app/components/LandingPage/LandingPageIntegrations/types';

export const integrations: LandingPageIntegrationData[] = [
  {
    description: 'womens_integrations_nc_copy',
    Logo: NaturalCyclesLogo,
    name: 'Natural Cycles',
  },
  {
    description: 'womens_integrations_clue_copy',
    Logo: ClueLogo,
    name: 'Clue',
  },
  {
    description: 'womens_integrations_flo_copy',
    Logo: FloLogo,
    name: 'Flo',
  },
  {
    description: 'womens_integrations_apple_health_copy',
    Logo: AppleLogo,
    name: 'Apple Health Kit',
  },
  {
    description: 'womens_integrations_health_connect_copy',
    Logo: GoogleHealthConnectLogo,
    name: 'Google Health Connect',
  },
];
